import Vue from 'vue'
import VueRouter from 'vue-router'
import Resource from 'vue-resource'
import Home from '../views/Home.vue'

Vue.use(VueRouter)
Vue.use(Resource)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
